import { type NodeRenderer } from '@contentful/rich-text-react-renderer'
import React from 'react'

export const quote: NodeRenderer = (node, children) => (
  <blockquote className="border-l-medium my-4 ml-0 border-solid border-l-theme-primary-main pl-[0.8125rem]">
    {children}
  </blockquote>
)
